import {
  Box, Skeleton, ThemeProvider, Typography, useTheme,
} from '@mui/material';
import { indigo } from '@mui/material/colors';
import { useEffect, useState } from 'react';
import { getPollResults, getPollTotalVotes } from '../../../api/contentAPI';
import { QuestionOption } from '../../../common/models/Question';
import { PollResult } from '../../../common/models/content/PollResult';
import { ContentTheme } from './ContentTheme';

export interface ContentPollAnswerViewProps {
  formId: string
  questionId: string
  questionType: string
  title?: string
  selectedOption: string
  options: QuestionOption[]
  onGetTotalVotes: (...event: number[]) => void;
}

export default function ContentPollAnswerView(props: ContentPollAnswerViewProps) {
  const [pollResults, setPollResults] = useState<PollResult>();
  const theme = useTheme();

  useEffect(() => {
    const getPollResultsResponse = getPollResults(props.questionId);
    const getPollTotalVotesResponse = getPollTotalVotes(props.questionId);
    Promise.all([getPollResultsResponse, getPollTotalVotesResponse])
      .then(([pollResultsResponse, totalVotesResponse]) => {
        setPollResults(pollResultsResponse);
        props.onGetTotalVotes(totalVotesResponse);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.questionId]);

  return (
    <ThemeProvider theme={ContentTheme}>
      <Box sx={{
        mt: 2,
        [theme.breakpoints.down('sm')]: {
          mt: 1,
        },
      }}>
        {pollResults ? (pollResults?.results.map((option, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: theme.spacing(1),
              mb: theme.spacing(1),
              position: 'relative',
            }}
          >
            {/* Background bar */}
            <Box
              sx={{
                position: 'absolute',
                height: '100%',
                width: `${option.percentage}%`,
                bgcolor:
                  (option.value as string) === (props.selectedOption) ? indigo[200] : 'lightgray',
                borderRadius: theme.spacing(1),
                zIndex: 0,
                transition: 'width 0.4s ease',
              }}
            />
            {/* Option text */}
            <Typography
              variant='h15'
              sx={{
                pl: theme.spacing(1.5),
                pr: theme.spacing(1.5),
                position: 'relative',
              }}
            >
              {option.display}
            </Typography>
            {/* Percentage text */}
            <Typography
              variant='h15'
              sx={{
                position: 'relative',
              }}
            >
              {option.percentage}%
            </Typography>
          </Box>
        ))) : (props.options?.map((item, index) => (
          <Skeleton
            key={index}
            animation='wave'
            height={10}
            variant='rectangular'
            sx={{
              borderRadius: theme.spacing(1),
              marginBottom: theme.spacing(3.5),
            }}
          />
        )))
        }
      </Box>
    </ThemeProvider>);
}
